<script setup lang="ts">
import Services from '../parts/Services.vue'
import ServicesWithSavings from '../parts/ServicesWithSavings.vue'
import ColumnsText from '../parts/ColumnsText.vue'
import ClientRating from '../parts/ClientRating.vue'
import Gallery from '../parts/Gallery.vue'
import Title from './../parts/Title.vue'
import type {
  ReferenceDetailResponse,
  ReferenceLandingPageItem,
} from '~/types/api/ReferenceDetail'

defineProps<{
  referenceDetail: ReferenceDetailResponse
}>()

function getComponent(landingPageItem: ReferenceLandingPageItem) {
  const componentsMap = {
    title: Title,
    // text:
    services: Services,
    services_with_savings: ServicesWithSavings,
    columns_text: ColumnsText,
    client_rating: ClientRating,
    gallery: Gallery,
  }

  if (!componentsMap[landingPageItem.type as keyof typeof componentsMap]) {
    console.warn(`Component name for type ${landingPageItem.type} not found`)

    return null
  }

  return componentsMap[landingPageItem.type as keyof typeof componentsMap]
}
</script>

<template>
  <div v-if="referenceDetail" class="c-references-detail-content">
    <template
      v-for="landingPageItem in referenceDetail?.landing_page_items"
      :key="landingPageItem.id"
    >
      <component
        :is="getComponent(landingPageItem)"
        v-if="getComponent(landingPageItem)"
        :key="landingPageItem.id"
        :landing-page-item="landingPageItem"
      />
    </template>
  </div>
</template>
